export default __webpack_public_path__ + "static/media/documenticon.d64af28c.svg";